import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "@emotion/react";
import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material"
import { Delete } from "@mui/icons-material";

const OPCIONES_TIPO = {
  4: JSON.stringify([{ label: null, value: 1 }, { label: null, value: 2 }])
}
const VALOR_PRELLENADO = {
  3: JSON.stringify([{ label: "min", value: null }, { label: "max", value: null }]),
  5: JSON.stringify([{ label: "min", value: null }, { label: "max", value: null }]),
  6: JSON.stringify([{ label: "min", value: null }, { label: "max", value: null }, { label: "mediciones", value: null }, { label: "muestra", value: null }])
}


export const CertificadoPregunta = ({ pregunta, index, padding = 2, indexSeccion, changeDataPregunta, standars, deletePregunta }) => {

  const theme = useContext(ThemeContext);

  const onChangeData = (field, value) => {
    changeDataPregunta(indexSeccion, index, field, value);
    if (field === "cupe_tipo") {
      changeDataPregunta(indexSeccion, index, "cupe_tipo", +value);
      changeDataPregunta(indexSeccion, index, "cupe_multiple", false);
      const tipo = parseInt(value);
      const nuevasOpciones = OPCIONES_TIPO[tipo] || null;
      changeDataPregunta(indexSeccion, index, "cupe_opciones", nuevasOpciones);
      const nuevoValorPrellenado = VALOR_PRELLENADO[tipo] || null;
      changeDataPregunta(indexSeccion, index, "cupe_valorprellenado", nuevoValorPrellenado);

      if (tipo === 5) {
        changeDataPregunta(indexSeccion, index, "stand_id", standars.length > 0 ? standars[0].value : null);
      } else {
        changeDataPregunta(indexSeccion, index, "stand_id", null);
      }
    }
  }

  const typeText = () => {
    return (
      <Grid item xs={12} sx={{ p: 2, mt: -1, textAlign: 'start' }} >
        <TextField
          id={`default_${index}`}
          label="Valor predeterminado"
          name={`default_${index}`}
          size="small"
          fullWidth
          multiline
          minRows={2}
          sx={{ color: theme.palette.primary.input }}
          defaultValue={pregunta?.cupe_valorprellenado}
          onChange={(e) => onChangeData("cupe_valorprellenado", e.target.value)}
        />
      </Grid>
    )
  }
  const typeNumber = () => {
    return (
      <Grid item xs={12} sx={{ p: 2, mt: -1, textAlign: 'start' }} >
        <TextField
          id={`default_${index}`}
          label="Valor predeterminado"
          name={`default_${index}`}
          size="small"
          type="number"
          fullWidth
          sx={{ color: theme.palette.primary.input }}
          defaultValue={pregunta?.cupe_valorprellenado}
          onKeyUp={(e) => onChangeData("cupe_valorprellenado", e.target.value)}
        />
      </Grid>
    )
  }
  const typeRange = () => {

    const onChangeRango = (position, value) => {
      if (pregunta?.cupe_valorprellenado) {
        let valorPrellenado = JSON.parse(pregunta.cupe_valorprellenado);
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      } else {
        let valorPrellenado = [
          { label: "min", value: null },
          { label: "max", value: null }
        ];
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      }
    }

    return (
      <>
        <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
          <TextField
            id="rango_min"
            name="rango_min"
            label="Mínimo predeterminado"
            sx={{ color: theme.palette.primary.input }}
            size="small"
            type="number"
            fullWidth
            defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[0].value}
            onChange={(e) => onChangeRango(0, e.target.value)}
          />
        </Grid>
        <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
          <TextField
            id="rango_max"
            name="rango_max"
            label="Máximo predeterminado  "
            sx={{ color: theme.palette.primary.input }}
            size="small"
            type="number"
            fullWidth
            defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[1].value}
            onChange={(e) => onChangeRango(1, e.target.value)}
          />
        </Grid>
      </>
    )
  }
  const typeOptions = () => {

    const onChangeDataOptions = (indexOpcion, label) => {
      let opciones = JSON.parse(pregunta.cupe_opciones);
      opciones[indexOpcion].label = label;
      onChangeData("cupe_opciones", JSON.stringify(opciones));
    }
    const deleteOption = (indexOpcion) => {
      let opciones = JSON.parse(pregunta.cupe_opciones);
      opciones.splice(indexOpcion, 1);
      onChangeData("cupe_opciones", JSON.stringify(opciones));
    }
    const addOption = () => {
      let opciones = JSON.parse(pregunta.cupe_opciones);
      opciones.push({ label: null, value: opciones.length + 1 });
      onChangeData("cupe_opciones", JSON.stringify(opciones));
    }

    return (
      <>
        <Grid item xs={9} sx={{ p: 0, mt: 0, textAlign: 'start' }}>
          <Grid item xs={12} sx={{ p: 0, mt: 0, textAlign: 'start' }}>
            {
              pregunta?.cupe_opciones && JSON.parse(pregunta.cupe_opciones).map((opcion, indexOpcion) => (
                <Grid key={`options_p_${index}_s_${indexSeccion}_l_${indexOpcion}`} item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                  {
                    pregunta?.cupe_multiple && (
                      <Checkbox key={`check_op_${indexOpcion}_pr_${index}_sec_${indexSeccion}`} disabled />
                    )
                  }
                  {
                    !pregunta?.cupe_multiple && (
                      <Radio key={`radio_op_${indexOpcion}_pr_${index}_sec_${indexSeccion}`} disabled />
                    )
                  }
                  <TextField
                    id={`opcion_${indexOpcion}_pr_${index}_sec_${indexSeccion}`}
                    name={`opcion_${indexOpcion}_pr_${index}_sec_${indexSeccion}`}
                    label={`Opción ${indexOpcion + 1}`}
                    sx={{ color: theme.palette.primary.input }}
                    size="small"
                    fullWidth
                    required
                    defaultValue={opcion?.label}
                    error={opcion?.label === null || opcion?.label === ''}
                    helperText={opcion?.label === null || opcion?.label === '' ? 'Ingrese un valor' : ''}
                    onChange={(e) => onChangeDataOptions(indexOpcion, e.target.value)}
                  />
                  {
                    JSON.parse(pregunta.cupe_opciones).length > 2 && (
                      <IconButton
                        size="large"
                        sx={{ ml: 1 }}
                        onClick={() => deleteOption(indexOpcion)}>
                        <Delete sx={{ fontSize: 25 }} />
                      </IconButton>
                    )
                  }
                </Grid>
              ))
            }
          </Grid>
        </Grid>
        <Grid item xs={3} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
          <FormControl error={pregunta?.cupe_multiple === null}>
            <FormLabel id="tipo_opciones">
              Tipo de opciones
            </FormLabel>
            <RadioGroup
              aria-labelledby="tipo_opciones"
              name="tipo_opciones"
              onChange={
                (e) => onChangeData("cupe_multiple", e.target.value === 'true' ? true : false)
              }
              defaultValue={pregunta?.cupe_multiple === 1 ? 'true' : 'false'}
            >
              <FormControlLabel value='false' control={<Radio />} label="Unica" />
              <FormControlLabel value='true' sx={{ mt: -2 }} control={<Radio />} label="Multiple" />
            </RadioGroup>
            <FormHelperText>
              {pregunta?.cupe_tipo === null ? 'Seleccione un tipo de opción' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={3} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
          <Button
            variant="contained"
            className="btn_system"
            onClick={() => addOption(index)}
          >
            Añadir opcion
          </Button>
        </Grid>
      </>
    )
  }
  const typeMediciones = () => {

    const onChangeRango = (position, value) => {
      if (pregunta?.cupe_valorprellenado) {
        let valorPrellenado = JSON.parse(pregunta.cupe_valorprellenado);
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      } else {
        let valorPrellenado = [
          { label: "min", value: null },
          { label: "max", value: null }
        ];
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      }
    }

    return (
      <>
        <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
          <TextField
            id={`med_min_preg_${index}_sec_${indexSeccion}`}
            name={`med_min_preg_${index}_sec_${indexSeccion}`}
            label="Mínimo predeterminado"
            sx={{ color: theme.palette.primary.input }}
            size="small"
            type="number"
            fullWidth
            defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[0].value}
            onChange={(e) => onChangeRango(0, e.target.value)}
          />
        </Grid>
        <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
          <TextField
            id={`med_max_preg_${index}_sec_${indexSeccion}`}
            name={`med_max_preg_${index}_sec_${indexSeccion}`}
            label="Máximo predeterminado"
            sx={{ color: theme.palette.primary.input }}
            size="small"
            type="number"
            fullWidth
            defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[1].value}
            onChange={(e) => onChangeRango(1, e.target.value)}
          />
        </Grid>
        <Grid item xs={8} sx={{ p: 2, mt: -1, textAlign: 'start' }}>
          <FormControl fullWidth size="small" error={pregunta?.stand_id === null || pregunta.stand_id === undefined}>
            <FormLabel id={`standar_label_pg_${index}_sec_${indexSeccion}`}>Estándar</FormLabel>
            <Select
              labelId={`standar_label_pg_${index}_sec_${indexSeccion}`}
              id={`standar_select_pg_${index}_sec_${indexSeccion}`}
              name={`standar_select_pg_${index}_sec_${indexSeccion}`}
              required
              value={pregunta?.stand_id}
              onChange={(e) => onChangeData("stand_id", e.target.value)}
            >
              {standars?.map(st => (
                <MenuItem value={st?.value}>{st?.label}</MenuItem>
              ))}
            </Select>
            {(pregunta?.stand_id === null || pregunta.stand_id === undefined) && <FormHelperText sx={{ ml: 0 }}>Seleccione un estándar</FormHelperText>}
          </FormControl>
        </Grid>
      </>
    )
  }
  const typeMedicionesSE = () => {

    const onChangeValue = (position, value) => {
      if (pregunta?.cupe_valorprellenado) {
        let valorPrellenado = JSON.parse(pregunta.cupe_valorprellenado);
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      } else {
        let valorPrellenado = JSON.parse(VALOR_PRELLENADO[6]);
        valorPrellenado[position].value = value;
        onChangeData("cupe_valorprellenado", JSON.stringify(valorPrellenado));
      }
    }

    return (
      <Grid item xs={12} sx={{ p: 0, textAlign: 'start' }}>
        <Grid container spacing={0} sx={{ mb: 1.5 }}>
          <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
            <TextField
              id={`mediciones_${index}_preg_${index}_sec_${indexSeccion}`}
              name={`mediciones_${index}_preg_${index}_sec_${indexSeccion}`}
              label="N° Mediciones"
              sx={{ color: theme.palette.primary.input }}
              size="small"
              type="number"
              fullWidth
              required
              defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[2]?.value}
              error={JSON.parse(pregunta?.cupe_valorprellenado)[2]?.value === null}
              onChange={(e) => onChangeValue(2, e.target.value)}
            />
          </Grid>
          <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
            <TextField
              id={`muestra_${index}_preg_${index}_sec_${indexSeccion}`}
              name={`muestra_${index}_preg_${index}_sec_${indexSeccion}`}
              label="Tamaño muestra"
              sx={{ color: theme.palette.primary.input }}
              size="small"
              type="number"
              fullWidth
              required
              defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[3]?.value}
              error={JSON.parse(pregunta?.cupe_valorprellenado)[3]?.value === null}
              onChange={(e) => onChangeValue(3, e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={0}>
          <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
            <TextField
              id={`ms_rango_min_preg_${index}_sec_${indexSeccion}`}
              name={`ms_rango_min_${index}_sec_${indexSeccion}`}
              label="Mínimo predeterminado"
              sx={{ color: theme.palette.primary.input }}
              size="small"
              type="number"
              fullWidth
              defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[0]?.value}
              onChange={(e) => onChangeValue(0, e.target.value)}
            />
          </Grid>
          <Grid item xs={4} sx={{ p: 2, mt: -3, textAlign: 'start' }}>
            <TextField
              id={`ms_rango_max_preg_${index}_sec_${indexSeccion}`}
              name={`ms_rango_max_${index}_sec_${indexSeccion}`}
              label="Máximo predeterminado"
              sx={{ color: theme.palette.primary.input }}
              size="small"
              type="number"
              fullWidth
              defaultValue={JSON.parse(pregunta?.cupe_valorprellenado)[1]?.value}
              onChange={(e) => onChangeValue(1, e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const chooseType = () => {
    switch (parseInt(pregunta.cupe_tipo)) {
      case 1:
        return typeText();
      case 2:
        return typeNumber();
      case 3:
        return typeRange();
      case 4:
        return typeOptions();
      // case 5:
      //   return typeMediciones();
      // case 6:
      //   return typeMedicionesSE();
    }
  }

  return (
    <Grid key={index} item xs={12} sx={{ p: padding, mt: 0, textAlign: 'start' }}>
      <Grid container spacing={0}>
        <Grid item xs={12} sx={{ p: 0, textAlign: 'start', display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
          <Typography id="transition-modal-title" variant="h8" component="h4">
            Pregunta {index + 1}
          </Typography>
          <IconButton
            size="large"
            sx={{ ml: 1 }}
            onClick={() => deletePregunta(index, indexSeccion)}>
            <Delete sx={{ fontSize: 25 }} />
          </IconButton>
        </Grid>
        <Grid item xs={9} sx={{ p: 0, mt: 0, textAlign: 'start' }}>
          <Grid key={`principal_data_${index}`} item xs={12} sx={{ p: 0, mt: 0, textAlign: 'start' }}>
            <Grid item xs={12} sx={{ p: 2, mt: 0, textAlign: 'start' }}>
              <TextField
                id={`pregunta_${index}`}
                name={`pregunta_${index}`}
                label="Pregunta"
                sx={{ color: theme.palette.primary.input }}
                size="small"
                fullWidth
                required
                defaultValue={pregunta.cupe_pregunta}
                onChange={(e) => onChangeData("cupe_pregunta", e.target.value)}
                error={pregunta?.cupe_pregunta === null ||
                  pregunta?.cupe_pregunta === ''}
                helperText={
                  pregunta?.cupe_pregunta === null ||
                    pregunta?.cupe_pregunta === '' ?
                    'Ingrese un valor' :
                    ''
                }

              />
            </Grid>
            <Grid item xs={12} sx={{ p: 2, mt: -1, textAlign: 'start' }} >
              <TextField
                id={`descripcion_${index}`}
                label="Descripción"
                name={`descripcion_${index}`}
                size="small"
                fullWidth
                multiline
                minRows={2}
                defaultValue={pregunta?.cupe_descripcion}
                onChange={(e) => onChangeData("cupe_descripcion", e.target.value)}
                sx={{ color: theme.palette.primary.input }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={3} sx={{ p: 2, mt: -1, textAlign: 'start' }} >
          <FormControl key={`type_q_${index}_${indexSeccion}`} error={pregunta?.cupe_tipo === null} required>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Tipo de pregunta
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onChange={(e) => onChangeData("cupe_tipo", e.target.value)}
              defaultValue={pregunta?.cupe_tipo}
            >
              <FormControlLabel value={1} control={<Radio />} label="Texto" />
              <FormControlLabel value={2} sx={{ mt: -2 }} control={<Radio />} label="Númerico" />
              <FormControlLabel value={3} sx={{ mt: -2 }} control={<Radio />} label="Rango" />
              <FormControlLabel value={4} sx={{ mt: -2 }} control={<Radio />} label="Opciones" />
              {/* <FormControlLabel value={5} sx={{ mt: -2 }} control={<Radio />} label="Mediciones" />
              <FormControlLabel value={6} sx={{ mt: -1.0, '& .MuiTypography-root': { lineHeight: 1 } }} control={<Radio />} label="Mediciones S/E" /> */}
            </RadioGroup>
            <FormHelperText>
              {pregunta?.cupe_tipo === null ? 'Seleccione un tipo' : ''}
            </FormHelperText>
          </FormControl>
        </Grid>
        {
          pregunta?.cupe_tipo && chooseType()
        }
      </Grid>
    </Grid>
  )
}